import { SupportedLocales } from "./configureI18n";

export enum ActionTypeKeys {
    CHANGE_LOCALE = 'I18N_CHANGE_LOCALE',
}

export interface I18nState {
    locale: SupportedLocales;
}